export default __webpack_public_path__ + "static/media/sbo-icon.c693f96b.svg";